import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";
import { ForecastingListTableColumn } from "./ForecastingListTableColumn";

import { useForecastingList } from "@hooks/inventory/forecasting/useForecastingList";

import { ForecastingResponseType } from "@type/inventory/forecasting";
import { Pagination } from "@type/inventory/pagination";
import { TablePagination } from "@helpers/tablePagination";

const ForecastingListTable = () => {
  const { t } = useTranslation();

  const { handleQuery, forecastingState } = useForecastingList();
  const { getData } = forecastingState;

  const { data, pagination } = getData || ({} as ForecastingResponseType);
  const { total } = pagination || ({} as Pagination);

  return (
    <div className="mt-10">
      <Table
        header={{
          title: t("INVENTORY_FORECASTING_LIST.HEADING"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        columns={ForecastingListTableColumn(t)}
        rows={data}
        // headerExtension={
        //   {
        // leftComponents: [
        //   <div className="d-flex gap-10 ">
        //     <Select
        //       name="category"
        //       size="xs"
        //       suffix={<IconChevronDown fill="dark" size="15" />}
        //       options={[{ value: 'value', label: 'label' }]}
        //     />
        //     <Select
        //       name="group"
        //       size="xs"
        //       suffix={<IconChevronDown fill="dark" size="15" />}
        //       options={[{ value: 'value', label: 'label' }]}
        //     />
        //     <Select
        //       name="type"
        //       size="xs"
        //       suffix={<IconChevronDown fill="dark" size="15" />}
        //       options={[{ value: 'value', label: 'label' }]}
        //     />
        //   </div>,
        // ],
        // rightComponents: [
        //   <div className="d-flex">
        //     <InputText
        //       name="simple-input"
        //       onChange={(e) => {
        //         console.log('onChange e:', e);
        //       }}
        //       prefix={<IconSearch fill="dark" size="20" />}
        //       size="sm"
        //       placeholder={t('PROCUREMENTS_LIST.SEARCH')}
        //       type="text"
        //     />
        //   </div>,
        // ],
        //   }
        // }
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};

export default ForecastingListTable;
